import * as TimeOffManagerActionCreator from "./TimeOffManagerActionCreator";

export function defaultTimeOffRequestsState() {
  return {
    loading: false,
    response: null,
    error: null,
    page: 0,
    size: 10,
    employeeName: "",
    sort: null
  };
}

export const TimeOffRequestsReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESET_TIMEOFF_REQUESTS_STATE
  ) {
    return { ...state, ...defaultTimeOffRequestsState() };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.REQUEST_TIMEOFF_REQUESTS) {
    return {
      ...state,
      loading: true,
      page: action.data.page,
      size: action.data.size,
      employeeName: action.data.employeeName || state?.employeeName || "",
      sort: action.data.sort || state?.sort || null,
      status: action.data.status || state?.status || null,
      response: null,
      error: null
    };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESPONSE_TIMEOFF_REQUESTS) {
    return { ...state, response: action.data, loading: false };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.ERROR_TIMEOFF_REQUESTS) {
    return {
      ...state,
      error: action.data,
      loading: false,
      response: null,
      page: 0,
      size: 10
    };
  }

  return state;
};


export function defaultApproveTimeOffRequestState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export function defaultGetTimeOffByIdState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export function defaultUpdateTimeOffRequestState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}



export const ApproveTimeOffRequestReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESET_APPROVE_TIMEOFF_REQUEST_STATE
  ) { 
    return { ...state, ...defaultApproveTimeOffRequestState() };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.REQUEST_APPROVE_TIMEOFF_REQUEST) {
    return { ...state, loading: true };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESPONSE_APPROVE_TIMEOFF_REQUEST) {
    return { ...state, response: action.data, loading: false };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.ERROR_APPROVE_TIMEOFF_REQUEST) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export const GetTimeOffByIdReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESET_GET_TIMEOFF_BY_ID_STATE
  ) { 
    return { ...state, ...defaultGetTimeOffByIdState() };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.REQUEST_GET_TIMEOFF_BY_ID) {
    return { ...state, loading: true };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESPONSE_GET_TIMEOFF_BY_ID) {
    return { ...state, response: action.data, loading: false };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.ERROR_GET_TIMEOFF_BY_ID) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export const UpdateTimeOffRequestReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESET_UPDATE_TIMEOFF_REQUEST_STATE
  ) { 
    return { ...state, ...defaultUpdateTimeOffRequestState() };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.REQUEST_UPDATE_TIMEOFF_REQUEST) {
    return { ...state, loading: true };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESPONSE_UPDATE_TIMEOFF_REQUEST) {
    return { ...state, response: action.data, loading: false };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.ERROR_UPDATE_TIMEOFF_REQUEST) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};

export function defaultCreateTimeOffRequestState() {
  return {
    loading: false,
    response: null,
    error: null,
  };
}

export const CreateTimeOffRequestReducer = (state, action) => {
  if (
    !state ||
    action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESET_CREATE_TIMEOFF_REQUEST_STATE
  ) {
    return { ...state, ...defaultCreateTimeOffRequestState() };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.REQUEST_CREATE_TIMEOFF_REQUEST) {
    return { ...state, loading: true };
  } 

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.RESPONSE_CREATE_TIMEOFF_REQUEST) {
    return { ...state, response: action.data, loading: false };
  }

  if (action.type === TimeOffManagerActionCreator.TIMEOFF_MANAGER_ACTION.ERROR_CREATE_TIMEOFF_REQUEST) {
    return { ...state, error: action.data, loading: false };
  }

  return state;
};